/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Hero_Pill_RegistryInputs */



/**
* | output |
* | --- |
* | "Checked 14 company records before onboarding" |
*
* @param {Integrations_Hero_Pill_RegistryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_hero_pill_registry = /** @type {((inputs?: Integrations_Hero_Pill_RegistryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Hero_Pill_RegistryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("14 Firmendaten vor dem Onboarding geprüft")
	return /** @type {LocalizedString} */ ("Checked 14 company records before onboarding")
});